import React from 'react'
import loadable from '@loadable/component'
import PropTypes from 'prop-types'
import { headerProps, heroProps, html } from './config'
import PageTemplate from '../components/templates/PageTemplate'

const StyledContent = loadable(() =>
  import('@albatross/common-components/dist/components/Content')
)
const HeroCanvas = loadable(() =>
  import('@albatross/common-components/dist/components/HeroCanvas')
)

const DynamicHeader = loadable(() =>
  import('@albatross/common-components/dist/components/DynamicHeader')
)

const ApolloError = (props) => {
  const { venture, ConfigContext } = props

  return (
    <PageTemplate components={[]}>
        <DynamicHeader venture={venture} globalConfig={headerProps[venture]} />
        <HeroCanvas
          venture={venture}
          ConfigContxt={ConfigContext}
          {...heroProps}
        />
        <StyledContent
          content={html}
          venture={venture}
        />
      </PageTemplate>
  )
}

ApolloError.propTypes = {
  venture: PropTypes.string,
  ConfigContext: PropTypes.object

}

export default ApolloError
